import { notificationMiddleWare } from "utils/NotificationMiddleWare";
import { apiBase } from "APIs/index";
import { AI_getEmployeeList } from "./employee";

// For get list of users details
export const AI_getUserList = apiBase.createListInstance({
    endpoint: "/user/{id}",
    method: "get",
    reducer: "userReducer",
    key: "id",
    reduxKey: "userData",
    action: "GET_USER_LIST",
    onSuccess: (data) => data.user
});
export const AI_getAllUserList = apiBase.createListInstance({
    endpoint: "/userlist",
    method: "get",
    reducer: "userReducer",
    key: "id",
    reduxKey: "userListData",
    action: "GET_ALL_USER_LIST",
    onSuccess: (data) => data.user
});

// For add user details
export const AI_addUser = apiBase.createInstance({
    endpoint: "/user",
    method: "post",
    reducer: "userReducer",
    reduxKey: "addUserData",
    action: "ADD_USER",
    onSuccess: (data) => {
        AI_getUserList.updateAction(
            data.user
        )
    },
    middleware : notificationMiddleWare,
});

// For update user details
export const AI_updateUser = apiBase.createInstance({
    endpoint: "/user/{id}",
    method: "put",
    reducer: "userReducer",
    reduxKey: "updateUserData",
    action: "UPDATE_User",
    onSuccess: (data) => {
        AI_getUserList.updateAction(
            [
                data.user
            ]
        )
    }
});

// For delete user form list
export const AI_deleteUser = apiBase.createInstance({
    endpoint: "/user/{id}",
    method: "delete",
    reducer: "userReducer",
    reduxKey: "deleteUserData",
    action: "DELETE_USER",
    onSuccess: (data) => {
        AI_getUserList.deleteAction(
            [parseInt(data.deleted_id)]
        )
    }
});

export const AI_getUserData = apiBase.createListInstance({
    endpoint: "/getuser",
    method: "get",
    reducer: "userReducer",
    key: "id",
    reduxKey: "userData",
    action: "GET_USER_DATA",
    onSuccess: (data) => data
});

export const AI_changeUserFlag = apiBase.createListInstance({
    endpoint: "/user-flag-manage/{id}",
    method: "put",
    reducer: "userReducer",
    key: "id",
    reduxKey: "changeUserFlag",
    action: "CHANGE_USER_FLAG",
    onSuccess: (data) => 
     {
         AI_getEmployeeList.updateAction(
            [
                data.employee
            ]
        )
    },
});

export const AI_sendMail = apiBase.createListInstance({
    endpoint: "/invite",
    method: "post",
    reducer: "userReducer",
    key: "id",
    reduxKey: "sendMail",
    action: "SEND_MAIL",
    onSuccess: (data) => data,
    middleware : notificationMiddleWare,
});

export const AI_dashboard = apiBase.createListInstance({
    endpoint: "/getDetails",
    method: "get",
    reducer: "userReducer",
    key: "id",
    reduxKey: "getDetails",
    action: "GET_DASHBOARD_DATA",
    onSuccess: (data) => data
});

export const AI_deleted_user = apiBase.createListInstance({
    endpoint : "/deleted-employee/",
    method : "get",
    reducer : "userReducer",
    key : "id",
    reduxKey : "getDeletedUserDetails",
    listPath: "data.rows",
    action : "GET_DELETED_USER_DATA",
    onSuccess : (data) => data.employee_list
})

export const AI_first_login = apiBase.createListInstance({
    endpoint : "/user-join/",
    method : "post",
    reducer : "userReducer",
    // key : "id",
    // reduxKey : "getDeletedUserDetails",
    action : "USER_JOIN",
    // onSuccess : (data) => data.employee_list
})

export const AI_global_search = apiBase.createInstance({
    endpoint : "/global-search",
    method : "get",
    reducer : "userReducer",
    key : "id",
    reduxKey : "getGlobalSearchList",
    action : "GLOBAL_SEARCH",
    onSuccess : (data) => data.list
})

export const AI_submit_form = apiBase.createInstance({
    endpoint : "/submit-form",
    method : "put",
    reducer : "userReducer",
    key : "id",
    reduxKey : "submitForm",
    action : "SUBMIT_FORM",
    onSuccess : (data) => data.user
})

export const AI_submit_bug_or_suggetion = apiBase.createInstance({
    endpoint : "/send-bug-or-suggetions",
    method : "post",
    reducer : "userReducer",
    key : "id",
    reduxKey : "submitBugOrSuggetion",
    action : "SEND_BUG_OR_SUGGETION",
    onSuccess : (data) => data,
    middleware : notificationMiddleWare
})

export const AI_user_attendance = apiBase.createInstance({
    endpoint : "http://122.170.107.160/biotime/employeeattendance",
    method : "post",
    reducer : "userReducer",
    key : "id",
    reduxKey : "uesr_attendance",
    action : "USER_ATTENDANCE",
    onSuccess : (data) => data,
})

// Attendance data
export const AI_employee_attendance_data = apiBase.createListInstance({
    endpoint : "/employee-attendance-data",
    method : "post",
    reducer : "userReducer",
    key : "id",
    reduxKey : "getEmployeeAttendanceData",
    action : "GET_EMPLOYEE_ATTENDANCE_DATA",
    onSuccess : (data) => data.employee_data
})

export const AI_all_employee_attendance_data = apiBase.createListInstance({
    endpoint : "/all-employee-attendance-data",
    method : "post",
    reducer : "userReducer",
    key : "id",
    reduxKey : "getAllEmployeeAttendanceData",
    action : "GET_ALL_EMPLOYEE_ATTENDANCE_DATA",
    // onSuccess : (data) => data.employee_data
    onSuccess: (data) =>
    data.employee_data.map((data) => ({
      ...data,
      emp_code: parseInt(data.emp_code),
    })),
})

export const AI_send_forgot_punch_mail = apiBase.createListInstance({
    endpoint : "/send-forgot-puch-mail",
    method : "post",
    reducer : "userReducer",
    key : "id",
    reduxKey : "sendForgotPunchMail",
    action : "SEND_FORGOT_PUNCH_MAIL",
    middleware : notificationMiddleWare
})

export const AI_punch_in_or_out = apiBase.createListInstance({
    endpoint : "/punch-in-or-out",
    method : "post",
    reducer : "userReducer",
    key : "id",
    reduxKey : "sendPunchInOrOut",
    action : "PUCN_IN_OR_OUT",
    middleware : notificationMiddleWare
})


// admin setting

export const AI_Admin_setting = apiBase.createListInstance({
    endpoint : "/admin-setting",
    method : "post",
    reducer : "userReducer",
    key : "id",
    reduxKey : "adminSetting",
    action : "ADMIN_SETTING",
    middleware : notificationMiddleWare
})

export const AI_admin_setting_value = apiBase.createListInstance({
    endpoint : "/get_ip_setting",
    method : "get",
    reducer : "userReducer",
    key : "id",
    reduxKey : "adminSettingValue",
    action : "ADMIN_SETTING_VALUE",
    onSuccess : (data) => data.setting
})

// monthly attendance report
export const AI_monthly_attendance_report = apiBase.createListInstance({
    endpoint : "/monthly-attendance-report",
    method : "post",
    reducer : "userReducer",
    key : "id",
    reduxKey : "getMonthlyAttendanceReport",
    action : "MONTHLY_ATTENDANCE_REPORT",
    onSuccess: (data) => data.employee_data,
})

export const AI_employeeForgotPunch = apiBase.createListInstance({
    endpoint : "/employee-forgot-punch",
    method : "post",
    reducer : "userReducer",
    key : "id",
    reduxKey : "employeeForgotPunch",
    action : "EMPLOYEE_FORGOT_PUNCH",
})

// =========================== FEEDBACK API ===========================

export const AI_send_feedback = apiBase.createInstance({
    endpoint : "/create-feedback",
    method : "post",
    reducer : "userReducer",
    key : "id",
    reduxKey : "sendFeedback",
    action : "SEND_FEEDBACK",
    onSuccess : (data) => data,
})

export const AI_get_feedbackList = apiBase.createInstance({
    endpoint : "/get-feedback",
    method : "get",
    reducer : "userReducer",
    key : "id",
    reduxKey : "getFeedbacks",
    action : "GET_FEEDBACKS",
    onSuccess : (data) => data,
})

export const AI_get_feedbackCount = apiBase.createInstance({
    endpoint : "/get-feedback-count",
    method : "get",
    reducer : "userReducer",
    key : "id",
    reduxKey : "getFeedbackCounts",
    action : "GET_FEEDBACK_COUNT",
    onSuccess : (data) => data.count,
})

export const AI_read_feedbackCount = apiBase.createInstance({
    endpoint : "/read-feedback",
    method : "post",
    reducer : "userReducer",
    key : "id",
    reduxKey : "readFeedbackCounts",
    action : "READ_FEEDBACK_COUNT",
    onSuccess : (data) => data,
})